var constants = require('../constants');

var facebookLikeModalActions = (function() {

    var _openFacebookLikeModal = function(triggerSource) {
        return {
            type: constants.OPEN_FACEBOOK_LIKE_MODAL,
            meta: {
                analytics: {
                    eventType: constants.OPEN_FACEBOOK_LIKE_MODAL,
                    actionValue: 'Open',
                    labelValue: triggerSource
                }
            }
        };
    }

    var _closeFacebookLikeModal = function(triggerSource) {
        return {
            type: constants.CLOSE_FACEBOOK_LIKE_MODAL,
            meta: {
                analytics: {
                    eventType: constants.CLOSE_FACEBOOK_LIKE_MODAL,
                    actionValue: 'Close',
                    labelValue: triggerSource
                }
            }
        };
    }

    return {
        openFacebookLikeModal: _openFacebookLikeModal,
        closeFacebookLikeModal: _closeFacebookLikeModal
    }
})();

module.exports = facebookLikeModalActions;



// WEBPACK FOOTER //
// ./src/common/modules/facebook-like-modal/actions/facebook-like-modal.js